export default __webpack_public_path__ + "static/media/hourglass_top.1f49895a.svg";